module.exports = __webpack_public_path__ + "img/telemedicine.927d90ba.webp";